document.addEventListener('DOMContentLoaded', function () {
    console.log('Script running'); // This line will log a message to the browser console

    const checkbox = document.getElementById('checkbox-1_1');
    const selectLabel = document.querySelector('label[for="select-1"]');
    const selectDropdown = document.getElementById('select-1');

    // Add the custom classes to the label and the select
    selectLabel.classList.add('gpo-select-label');
    selectDropdown.classList.add('gpo-select-dropdown');

    const updateSelectStatus = function () {
        const isChecked = checkbox.checked;
        selectLabel.classList.toggle('gpo-disabled', !isChecked);
        selectDropdown.disabled = !isChecked;
    };

    checkbox.addEventListener('change', updateSelectStatus);
    updateSelectStatus();
});

async function brandSelectHome() {
    const field1 = document.getElementById('field1');
    const field2 = document.getElementById('field2');
    const kentekenInput = document.querySelector('.centeredkenteken--home input');
    const submitBtn = document.querySelector('.submit-btn');

    if (!field1 || !field2 || !submitBtn) {
        return;
    }

    let carData;

    // Fetch the car data from the JSON file with cache busting
    async function fetchCarData() {
        const version = new Date().getTime(); // Cache-busting query parameter
        const response = await fetch(`//www.caroptions.nl/cdn/shop/t/4/assets/home_page_license_plate_selector.json?v=${version}`);
        carData = await response.json();
    }

    await fetchCarData();

    // Populate the field1 select element with car brands
    function populateBrands() {
        Object.keys(carData).forEach(brand => {
            const option = document.createElement('option');
            option.value = brand.toLowerCase();
            option.text = brand.charAt(0).toUpperCase() + brand.slice(1);
            field1.appendChild(option);
        });
    }

    populateBrands();

    function insertType(_value) {
        let selectedBrand = _value || field1.value;
        const selectedData = carData[selectedBrand];

        field2.innerHTML = '';

        // Add default option
        const typeOption = document.createElement('option');
        typeOption.value = '';
        typeOption.text = 'Type';
        field2.appendChild(typeOption);

        if (selectedData && selectedData.models) {
            selectedData.models.forEach(model => {
                const option = document.createElement('option');
                option.value = model.value.toLowerCase();
                option.text = model.value;
                
                if (model.var) {
                    option.setAttribute('data-var', model.var);
                } else if (model.url) {
                    option.setAttribute('data-url', model.url);
                }

                field2.appendChild(option);
            });

            // Store brand URL
            field2.setAttribute('data-url', selectedData.url || '');
        }
    }

    field1.addEventListener('change', function () {
        insertType(this.value);
    });

    insertType();

    function submit() {
        const selectedBrand = field1.value;
        const selectedOption = field2.options[field2.selectedIndex];
        const dataVar = selectedOption.getAttribute('data-var');
        const selectedUrl = selectedOption.getAttribute('data-url') || field2.getAttribute('data-url');

        if (kentekenInput.value) {
            startKentekenFetcher(kentekenInput);
            setTimeout(() => {
                if (selectedUrl) {
                    window.location.href = dataVar ? `${selectedUrl}?variant=${dataVar}` : selectedUrl;
                }
            }, 1000);
        } else if (selectedUrl) {
            window.location.href = dataVar ? `${selectedUrl}?variant=${dataVar}` : selectedUrl;
        }
    }

    kentekenInput.addEventListener('keyup', event => {
        if (event.key === "Enter") {
            submit();
        }
    });

    submitBtn.addEventListener('click', function () {
        submit();
    });
}

brandSelectHome();


function openCarPlayBoxModal() {
    var htmlModal = `
      <div class="custom-modal--background"></div>
      <div class="custom-modal--wrapper">
          <div class="custom-modal--close"></div>
          <div class="custom-modal--inner">
              <h2>CarPlayBox bestellen</h2>
              <div class="custom-modal--content">
                  <p>Vul je kenteken in of selecteer je merk</p>
                  <div class="centeredkenteken">
                      <div class="kenteken">
                          <div class="inset">
                              <div class="blue"></div>
                              <input type="text" placeholder="" value="">
                          </div>
                      </div>
                      <input type="submit" value="ZOEKEN" id="checkbutton">
                  </div>
              </div>
              <div class="custom-modal--seprator">
                <span>OF</span>
              </div>
              <div class="custom-modal--brands">
                  <header>Kies je merk</header>
                  <div class="custom-modal--brands--list">
                      <a href="https://www.caroptions.nl/products/carplaybox-volkswagen">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/vw_965113a2-d049-4814-9711-0c59f97247c0.png?v=1687983423" alt="Volkwagen" title="Volkwagen">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-porsche">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/porsche_1bc20035-ea19-4fee-8857-eeb9cf4f5cd2.png?v=1687983488" alt="Porsche" title="Porsche">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-mini">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/mini_1d29cba7-7130-4858-99a5-e73c3f263380.png?v=1687983821" alt="Mini" title="Mini">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-bmw">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/bmw_3b484f3e-b08d-4c60-8cb6-a5ddee37ab1e.png?v=1687983837" alt="BMW" title="BMW">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-mercedes">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/merc_04dfdc7e-91a5-4ace-ad3a-f8c43002594b.png?v=1687983853" alt="Mercedes" title="Mercedes">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-audi">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/audi_d358cdbb-e243-44c8-98ff-da73bf4f226c.png?v=1687983866" alt="Audi" title="Audi">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-seat">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/seat_2af06407-6ea7-4e71-aa48-c8f831627fe8.png?v=1687983878" alt="Seat" title="Seat">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplay-android-auto-voor-mazda">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/mazdalogo.png?v=1731281733" alt="Mazda" title="Mazda">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-citroen">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/Untitled-2.png?v=1726684532" alt="Citroen" title="Citroen">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-bentley">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/logo_dca11a99-3d13-404d-b77b-de98b11a81b4.png?v=1698241023" alt="Bentley" title="Bentley">
                      </a>

                      <a href="https://www.caroptions.nl/products/rolls-royce">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/logo_ef3ae425-3c9d-4b0f-a9c9-a3367e2569ae.png?v=1698232682" alt="Rolls Royce" title="Rolls Royce">
                      </a>
                      
                      <a href="https://www.caroptions.nl/products/carplaybox-alfa-romeo">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/alfa.png?v=1698234153" alt="Alfa Romeo" title="Alfa Romeo">
                      </a>
                      
                      <a href="https://www.caroptions.nl/products/carplaybox-land-rover">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/landrover.png?v=1698234605" alt="Land Rover" title="Land Rover">
                      </a>
                      
                      <a href="https://www.caroptions.nl/products/carplaybox-toyota">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/logo_15cefb29-65e1-41e9-a3f3-ee1ae6f65b0b.png?v=1731288072" alt="Toyota" title="Toyota">
                      </a>
                      
                      <a href="https://www.caroptions.nl/products/carplaybox-volvo">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/volvo_acb51cd1-e86d-4e8e-ad3f-5e5a45f112d6.png?v=1687983895" alt="Volvo" title="Volvo">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-skoda">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/skoda_a013c339-5289-48b1-abfd-35498dbd4c2f.png?v=1687983911" alt="Skoda" title="Skoda">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-lexus">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/lexus_266491af-f5a4-46eb-b43d-dfe7168ca1f3.png?v=1687983923" alt="Lexus" title="Lexus">
                      </a>
                      <a href="https://www.caroptions.nl/products/carplaybox-dodge">
                          <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/logo_f4af9ecc-08fb-4245-b1ab-d7dca433405e.png?v=1731894271" alt="Dodge" title="Dodge">
                      </a>
                  </div>
              </div>
          </div>
      </div>`;

    const getAllButtons = document.querySelectorAll('a[href="/openmodal"]');

    if (getAllButtons && getAllButtons.length) {
        getAllButtons.forEach(item => {
            item.addEventListener('click', e => {
                e.preventDefault();

                activatePopUp(htmlModal);

                const getField = document.querySelector('.custom-modal .centeredkenteken input');
                const getButton = document.querySelector('.custom-modal #checkbutton');

                startKentekenFetcher(getField, getButton);
            })
        });
    }
}

openCarPlayBoxModal();

function carouselProductSliderCenter() {
    const getProductSlider = document.querySelector('.t4s-carousel__nav');
    const getItems = getProductSlider ? getProductSlider.querySelectorAll('.t4s-col-item') : false;

    if (!getProductSlider || !getItems || !getItems.length) {
        return;
    }

    const getSliderWidth = getProductSlider.offsetWidth;
    const getItemWidth = getItems[0].offsetWidth;

    if (getSliderWidth < getItemWidth * getItems.length) {
        getProductSlider.style.justifyContent = 'flex-start';
    } else {
        getProductSlider.style.justifyContent = 'center';
    }
}

carouselProductSliderCenter();

window.addEventListener('resize', carouselProductSliderCenter);

function locationPicker() {
    const locationSelectorWrapper = document.querySelector('.location_selector');
    const locationSelector = document.querySelector('.location_selector select');
    const productIdElement = document.querySelector('input[name="product-id"]');

    if (!locationSelector || !productIdElement) return;

    const productId = productIdElement.value;

    if (!productId) return;

    const hiddenLocations = {};
    // "caroptionsElburg": ["8232825323811", "8163665772835", "8229767020835", "9755033141582", "8199566491939", "8400368009550", "9753006145870", "9021283107150", "9857903886670"], // MINI, BMW, Mercedes, Citroen, Volvo, Lexus, Alfa Romeo, Land Rover, Dodge

    const shouldHideLocation = (locationKey, optionSelectorValue) => {
        const isOptionHidden = !locationSelector.querySelector(`option[value="${optionSelectorValue}"]`);
        const isProductHidden = hiddenLocations[locationKey] && hiddenLocations[locationKey].includes(productId);
        return isOptionHidden || isProductHidden;
    };

    const pickLocation = _select => {
        if (!_select.option) return;

        switch (_select.option) {
            case 'exclusive':
                locationSelector.value = 'Installatie exlusief';
                break;
            case 'caroptionsBleiswijk':
                locationSelector.value = 'CarOptions - Bleiswijk';
                break;
            case 'knippels':
                locationSelector.value = 'CarOptions - Brabant';
                break;
            case 'caroptionsWaalwijk':
                locationSelector.value = 'CarOptions - Waalwijk';
                break;
            case 'caroptionsApeldoorn':
                locationSelector.value = 'CarOptions - Apeldoorn';
                break;
            case 'caroptionsDeGoorn':
                locationSelector.value = 'CarOptions - De Goorn';
                break;
            case 'caroptionsEnkhuizen':
                locationSelector.value = 'CarOptions - Enkhuizen';
                break;
            case 'caroptionsMaastricht':
                locationSelector.value = 'CarOptions - Maastricht';
                break;
            case 'caroptionsElburg':
                locationSelector.value = 'CarOptions - Elburg';
                break;
            case 'haag':
                locationSelector.value = 'Haaglanden Motorsport';
                break;
        }

        const theCustomModal = document.querySelector('.custom-modal');
        theCustomModal.remove();

        var event = new Event('change');
        locationSelector.dispatchEvent(event);
    };

    const firstOption = locationSelector.querySelector('option');
    firstOption.innerText = 'Kies een locatie';

    function activateLocationPicker() {
        var htmlLocationPicker = `
      <div class="custom-modal--background"></div>
      <div class="custom-modal--wrapper">
          <div class="custom-modal--close"></div>
          <div class="custom-modal--inner">
              <h2>Locatie kiezen</h2>
              <div class="custom-modal--content">
                <p>Een werkruimte, koffie/thee en gratis wifi zijn inbegrepen bij alle punten. Installatie duurt ca. 1-2 uur.</p>
                <mark data-state="warning">Onze planning neemt binnen 24 uur contact op voor het maken van een afspraak</mark>
              </div>
              <div class="custom-modal--location">
                <header>Kies je locatie</header>
                <div class="custom-modal--location--items">
                    <div class="custom-modal--location--item ${shouldHideLocation('exclusive', 'Installatie exlusief') ? 'hidden' : ''}">
                        <div class="custom-modal--location--item--map">
                            <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/map_caroptions.jpg?v=1688424353">
                        </div>
                        <div class="custom-modal--location--item--content">
                            <header>CarOptions - <small>Hoofdvestiging Bleiswijk</small></header>
                            <p>Briljantstraat 33 - 2665NJ Bleiswijk</p>
                            <div class="custom-modal--location--item--cta">
                                <button
                                    data-location="exclusive"
                                    data-product-handle="${!locationSelector.querySelector('option[value="Installatie exlusief"]') ? '' : locationSelector.querySelector('option[value="Installatie exlusief"]').getAttribute('gpo-data-product-handle')}"
                                    data-variant="${!locationSelector.querySelector('option[value="Installatie exlusief"]') ? '' : locationSelector.querySelector('option[value="Installatie exlusief"]').getAttribute('gpo-data-variant-id')}"
                                >
                                    Kies
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <div class="custom-modal--location--item ${shouldHideLocation('caroptionsBleiswijk', 'CarOptions - Bleiswijk') ? 'hidden' : ''}">
                        <div class="custom-modal--location--item--map">
                            <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/map_caroptions_bleiswijk.jpg?v=1729421547">
                        </div>
                        <div class="custom-modal--location--item--content">
                            <header>CarOptions Bleiswijk <small>Hoofdvestiging</small></header>
                            <p>Briljantstraat 33 - 2665NJ Bleiswijk</p>
                            <div class="custom-modal--location--item--cta">
                                <button
                                    data-location="caroptionsBleiswijk"
                                    data-product-handle="${!locationSelector.querySelector('option[value="CarOptions - Bleiswijk"]') ? '' : locationSelector.querySelector('option[value="CarOptions - Bleiswijk"]').getAttribute('gpo-data-product-handle')}"
                                    data-variant="${!locationSelector.querySelector('option[value="CarOptions - Bleiswijk"]') ? '' : locationSelector.querySelector('option[value="CarOptions - Bleiswijk"]').getAttribute('gpo-data-variant-id')}"
                                >
                                    Kies
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <div class="custom-modal--location--item ${shouldHideLocation('caroptionsEnkhuizen', 'CarOptions - Enkhuizen') ? 'hidden' : ''}">
                        <div class="custom-modal--location--item--map">
                            <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/map_caroptions_de_goorn.jpg?v=1729904105">
                        </div>
                        <div class="custom-modal--location--item--content">
                            <header>CarOptions Enkhuizen <small>Noord Holland</small></header>
                            <p>De Tocht 2a - 1611HT Bovenkarspel</p>
                            <div class="custom-modal--location--item--cta">
                                <button
                                    data-location="caroptionsEnkhuizen"
                                    data-product-handle="${!locationSelector.querySelector('option[value="CarOptions - Enkhuizen"]') ? '' : locationSelector.querySelector('option[value="CarOptions - Enkhuizen"]').getAttribute('gpo-data-product-handle')}"
                                    data-variant="${!locationSelector.querySelector('option[value="CarOptions - Enkhuizen"]') ? '' : locationSelector.querySelector('option[value="CarOptions - Enkhuizen"]').getAttribute('gpo-data-variant-id')}"
                                >
                                    Kies
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="custom-modal--location--item ${shouldHideLocation('caroptionsElburg', 'CarOptions - Elburg') ? 'hidden' : ''}">
                        <div class="custom-modal--location--item--map">
                            <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/caroption_elburg.jpg?v=1730458129">
                        </div>
                        <div class="custom-modal--location--item--content">
                            <header>CarOptions Elburg <small>Gelderland</small></header>
                            <p>Broeklandstraat 8 - 8082AE Elburg</p>
                            <div class="custom-modal--location--item--cta">
                                <button
                                    data-location="caroptionsElburg"
                                    data-product-handle="${!locationSelector.querySelector('option[value="CarOptions - Elburg"]') ? '' : locationSelector.querySelector('option[value="CarOptions - Elburg"]').getAttribute('gpo-data-product-handle')}"
                                    data-variant="${!locationSelector.querySelector('option[value="CarOptions - Elburg"]') ? '' : locationSelector.querySelector('option[value="CarOptions - Elburg"]').getAttribute('gpo-data-variant-id')}"
                                >
                                    Kies
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="custom-modal--location--item ${shouldHideLocation('caroptionsMaastricht', 'CarOptions - Maastricht') ? 'hidden' : ''}">
                        <div class="custom-modal--location--item--map">
                            <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/caroption_limburg.jpg?v=1730452271">
                        </div>
                        <div class="custom-modal--location--item--content">
                            <header>CarOptions Maastricht <small>Limburg</small></header>
                            <p>Fregatweg 124 - 6222NZ Maastricht</p>
                            <div class="custom-modal--location--item--cta">
                                <button
                                    data-location="caroptionsMaastricht"
                                    data-product-handle="${!locationSelector.querySelector('option[value="CarOptions - Maastricht"]') ? '' : locationSelector.querySelector('option[value="CarOptions - Maastricht"]').getAttribute('gpo-data-product-handle')}"
                                    data-variant="${!locationSelector.querySelector('option[value="CarOptions - Maastricht"]') ? '' : locationSelector.querySelector('option[value="CarOptions - Maastricht"]').getAttribute('gpo-data-variant-id')}"
                                >
                                    Kies
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="custom-modal--location--item ${shouldHideLocation('caroptionsApeldoorn', 'CarOptions - Apeldoorn') ? 'hidden' : ''}">
                        <div class="custom-modal--location--item--map">
                            <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/partner_locatie_apeldoorn.jpg?v=1735558870">
                        </div>
                        <div class="custom-modal--location--item--content">
                            <header>CarOptions Apeldoorn <small>Gelderland</small></header>
                            <p>Sleutelbloemstraat - 7322AG Apeldoorn</p>
                            <div class="custom-modal--location--item--cta">
                                <button
                                    data-location="caroptionsApeldoorn"
                                    data-product-handle="${!locationSelector.querySelector('option[value="CarOptions - Apeldoorn"]') ? '' : locationSelector.querySelector('option[value="CarOptions - Apeldoorn"]').getAttribute('gpo-data-product-handle')}"
                                    data-variant="${!locationSelector.querySelector('option[value="CarOptions - Apeldoorn"]') ? '' : locationSelector.querySelector('option[value="CarOptions - Apeldoorn"]').getAttribute('gpo-data-variant-id')}"
                                >
                                    Kies
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="custom-modal--location--item ${shouldHideLocation('caroptionsWaalwijk', 'CarOptions - Waalwijk') ? 'hidden' : ''}">
                        <div class="custom-modal--location--item--map">
                            <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/map_caroptions_waalwijk.jpg?v=1729421547">
                        </div>
                        <div class="custom-modal--location--item--content">
                            <header>CarOptions Waalwijk <small>Brabant</small></header>
                            <p>Kleiweg - 5145PW Waalwijk</p>
                            <div class="custom-modal--location--item--cta">
                                <button
                                    data-location="caroptionsWaalwijk"
                                    data-product-handle="${!locationSelector.querySelector('option[value="CarOptions - Waalwijk"]') ? '' : locationSelector.querySelector('option[value="CarOptions - Waalwijk"]').getAttribute('gpo-data-product-handle')}"
                                    data-variant="${!locationSelector.querySelector('option[value="CarOptions - Waalwijk"]') ? '' : locationSelector.querySelector('option[value="CarOptions - Waalwijk"]').getAttribute('gpo-data-variant-id')}"
                                >
                                    Kies
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="custom-modal--location--item ${shouldHideLocation('caroptionsDeGoorn', 'CarOptions - De Goorn') ? 'hidden' : ''}">
                        <div class="custom-modal--location--item--map">
                            <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/map_caroptions_de_goorn.jpg?v=1729904105">
                        </div>
                        <div class="custom-modal--location--item--content">
                            <header>CarOptions De Goorn <small>Noord Holland</small></header>
                            <p>Schoffel - 1648 GG De Goorn</p>
                            <div class="custom-modal--location--item--cta">
                                <button
                                    data-location="caroptionsDeGoorn"
                                    data-product-handle="${!locationSelector.querySelector('option[value="CarOptions - De Goorn"]') ? '' : locationSelector.querySelector('option[value="CarOptions - De Goorn"]').getAttribute('gpo-data-product-handle')}"
                                    data-variant="${!locationSelector.querySelector('option[value="CarOptions - De Goorn"]') ? '' : locationSelector.querySelector('option[value="CarOptions - De Goorn"]').getAttribute('gpo-data-variant-id')}"
                                >
                                    Kies
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="custom-modal--location--item ${shouldHideLocation('haag', 'Haaglanden Motorsport') ? 'hidden' : ''}">
                          <div class="custom-modal--location--item--map">
                              <img src="https://cdn.shopify.com/s/files/1/0727/7477/9171/files/map_caroptions_bleiswijk.jpg?v=1729421547">
                          </div>
                          <div class="custom-modal--location--item--content">
                              <header>Haaglanden Motorsport B.V. - <small>CarOptions Partner</small></header>
                              <p>Gildeweg 10 - 2632BA Nootdorp (Zuid-Holland)</p>
                              <div class="custom-modal--location--item--cta">
                                  <button
                                      data-location="haag"
                                      data-product-handle="${!locationSelector.querySelector('option[value="Haaglanden Motorsport"]') ? '' : locationSelector.querySelector('option[value="Haaglanden Motorsport"]').getAttribute('gpo-data-product-handle')}"
                                      data-variant="${!locationSelector.querySelector('option[value="Haaglanden Motorsport"]') ? '' : locationSelector.querySelector('option[value="Haaglanden Motorsport"]').getAttribute('gpo-data-variant-id')}"
                                  >
                                      Kies
                                  </button>
                              </div>
                          </div>
                      </div>
                </div>
              </div>
          </div>
      </div>`;

        activatePopUp(htmlLocationPicker);

        const allButtons = document.querySelectorAll('.custom-modal--location--item button');

        if (allButtons && allButtons.length) {
            allButtons.forEach(button => {
                button.addEventListener('click', () => {
                    pickLocation({
                        option: button.dataset.location,
                        handle: button.dataset.productHandle,
                        variant: button.dataset.variant
                    });
                });
            });
        }
    }

    // Modal action
    locationSelectorWrapper.addEventListener('click', () => {
        activateLocationPicker();
    });

    const checkbox = document.querySelector('input[data-type="switch"][name="Montage en Installatie"]');

    if (checkbox) {
        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                setTimeout(function () {
                    activateLocationPicker();
                }, 300);
            }
        });
    }
}

let intervalTimeLocationPicker = 100;
let attemptsLocationPicker = 0;

const checkLocationPickerIsSet = () => {
    const locationSelector = document.querySelector('.location_selector select');

    if (locationSelector) {
        console.log('This is a hit');
        locationPicker(); // Initialiseer de locationPicker functie
        clearInterval(intervalLocationPicker); // Wis het interval zodra de functie is geïnitialiseerd
    } else {
        console.log('This NOT a hit');
        attemptsLocationPicker++;
        if (attemptsLocationPicker < 10) { // Probeer het een beperkt aantal keer om oneindige loops te voorkomen
            intervalTimeLocationPicker *= 2; // Optioneel: verhoog de intervaltijd bij elke poging
            clearInterval(intervalLocationPicker);
            intervalLocationPicker = setInterval(checkLocationPickerIsSet, intervalTimeLocationPicker);
        } else {
            clearInterval(intervalLocationPicker); // Wis het interval als het element na meerdere pogingen niet wordt gevonden
        }
    }
}

let intervalLocationPicker = setInterval(checkLocationPickerIsSet, intervalTimeLocationPicker);

var getProductSelector = document.querySelector('.t4s-product__select');
var deliveryTime = document.querySelector('.custom-benefits-below-add-to-cart .delivery_time');

function changeStock() {
    var getSelectVal = getProductSelector.value;

    if (getSelectVal) {
        var getSelectedValue = getProductSelector.querySelector(`option[value="${getSelectVal}"]`);

        if (getSelectedValue) {
            var getInventoryStock = getSelectedValue.dataset.inventoryquantity;

            console.log('test', getInventoryStock);

            if (parseInt(getInventoryStock) < 1 || !getInventoryStock) {
                // Niet op voorraad
                deliveryTime.style.display = "none";
            } else {
                // Op voorraad
                deliveryTime.style.display = "block";
            }
        } else {
            deliveryTime.style.display = "none";
        }
    }
}

if (getProductSelector && deliveryTime) {
    getProductSelector.addEventListener('change', (event) => {
        changeStock();
    });

    changeStock();
}

function faqCollapse() {
    const collapseChat = document.querySelector('.nav-link[href="#collapsechat"]');
    const collapseMail = document.querySelector('.nav-link[href="#collapsemail"]');
    const collapsePhone = document.querySelector('.nav-link[href="#collapsephone"]');

    const allCollapse = document.querySelectorAll('.categories-list-item .nav-link');

    if (!allCollapse || !allCollapse.length) return;

    allCollapse.forEach(item => {
        const href = item.getAttribute('href');

        if (href) {

            const getCollapseArea = document.querySelector('.collapse[data-href="' + href + '"]');

            if (getCollapseArea) {
                item.addEventListener('click', e => {
                    const getAllCollapse = document.querySelectorAll('.foldout-collapse');

                    if (!getAllCollapse || !getAllCollapse.length) return;

                    getAllCollapse.forEach(col => {
                        col.classList.remove('in');
                    });

                    if (getCollapseArea.classList.contains('in')) {
                        getCollapseArea.classList.remove('in');
                    } else {
                        getCollapseArea.classList.add('in');
                    }
                });
            }
        }
    });
}

faqCollapse();

const brandsVariations = [
    {
        title: 'Lexus',
        productid: '8400368009550',
        description: 'Kies één van de onderstaande opties wat aansluit bij jouw huidige systeem',
        images: [
            {
                value: 'Joystick besturing',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/lexus_joystick.jpg?v=1690443703'
            },
            {
                value: 'Groot touchpad besturing',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/lexus_touch_groot.jpg?v=1690443703'
            },
            {
                value: 'Klein touchpad besturing',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/lexus_kleine_touch.jpg?v=1690443703'
            },
            {
                value: 'Draaiknop besturing',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/lexus_draai.jpg?v=1690443703'
            }
        ]
    },
    {
        title: 'Mini',
        productid: '8232825323811',
        description: 'Kies één van de onderstaande opties wat aansluit bij jouw huidige systeem',
        images: [
            {
                value: 'NBT',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/mini_idrive_4.jpg?v=1690446484'
            },
            {
                value: 'EVO',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/EVO.png?v=1730769465'
            }
            ,
            {
                value: 'CIC',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/cic.png?v=1730769464'
            },
            {
                value: 'CCC',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/ccc.png?v=1730769465'
            }
        ]
    },
    {
        title: 'Mercedes',
        productid: '8229767020835',
        description: 'Kies één van de onderstaande opties wat aansluit bij jouw huidige systeem',
        images: [
            {
                value: 'NTG 3.0',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/ntg3.0.jpg?v=1713869674',
                order: 1
            },
            {
                value: 'NTG 3.5',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/ntg3.5.jpg?v=1713869648',
                order: 2
            },
            {
                value: 'NTG 4.0',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/ntg4.0.jpg?v=1713875303',
                order: 3
            },
            {
                value: 'NTG 4.5 / 4.7',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/ntg4.5.jpg?v=1713875408',
                order: 4
            },
            {
                value: 'NTG 5.0',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/ntg5.0.jpg?v=1713882384',
                order: 5
            },
            {
                value: 'NTG 5.5',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/ntg5.5.jpg?v=1713871582',
                order: 6
            },
            {
                value: 'NTG 6.0',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/NTG6.0.jpg?v=1693656835',
                order: 7
            }
        ]
    },
    {
        title: 'BMW',
        productid: '8163665772835',
        description: 'Kies één van de onderstaande opties wat aansluit bij jouw huidige systeem',
        images: [
            {
                value: 'CCC',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/CCC.jpg?v=1698149729',
                order: 1
            },
            {
                value: 'CIC',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/CIC.jpg?v=1698149729',
                order: 2
            },
            {
                value: 'NBT',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/NBT.jpg?v=1698149730',
                order: 3
            },
            {
                value: 'EVO',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/EVO.jpg?v=1698149729',
                order: 4
            },
            {
                value: 'EVO',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/EVO2.jpg?v=1698149729',
                order: 5
            }
        ]
    },
    {
        title: 'Range Rover',
        productid: '9021283107150',
        description: 'Kies één van de onderstaande opties wat aansluit bij jouw huidige systeem',
        images: [
            {
                value: 'Harman systeem',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/harman.jpg?v=1719525834'
            },
            {
                value: 'Bosch systeem',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/bosch_79c6cb14-a43d-48f8-a9aa-5c4f111c0856.jpg?v=1719524966'
            }
        ]
    },
    {
        title: 'Rolls Royce',
        productid: '8598902964558',
        description: 'Kies één van de onderstaande opties wat aansluit bij jouw huidige systeem',
        images: [
            {
                value: 'CCC',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/CCC.jpg?v=1698149729'
            },
            {
                value: 'CIC',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/CIC.jpg?v=1698149729'
            },
            {
                value: 'NBT',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/NBT.jpg?v=1698149730'
            },
            {
                value: 'EVO',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/EVO.jpg?v=1698149729'
            }
        ]
    },
    {
        title: 'Volvo',
        productid: '8199566491939',
        description: 'Kies één van de onderstaande opties wat aansluit bij jouw huidige systeem',
        images: [
            {
                value: 'Klein scherm',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/volvo_screen_1.jpg?v=1733093136',
                comment: 'Geleverd tussen 2010 en 2019'
            },
            {
                value: 'Groot scherm',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/volvo_screen_2.jpg?v=1733093137',
                comment: 'Geleverd tussen 2019 en Heden'
            }
        ]
    },
    {
        title: 'Audi',
        productid: '8404478198094',
        description: `Kies één van de onderstaande opties wat aansluit bij jouw huidige systeem.`,
        images: [
            {
                value: 'Basis Radio',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/a4_radio_1.jpg?v=1691332982',
                comment: 'Radio besturing onder ventilatierooster'
            },
            {
                value: '3GMMI / HN',
                types: [
                    {
                        type: 'A4',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/a4_radio_2.jpg?v=1691333005',
                        comment: 'Navigatie besturing naast versnellingspook - bouwjaar voor 1 Dec 2015'
                    },
                    {
                        type: 'A5',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/a4_radio_2.jpg?v=1691333005',
                        comment: 'Navigatie besturing naast versnellingspook - bouwjaar voor 1 Juni 2015'
                    },
                    {
                        type: 'Q5',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/q5_radio_2.jpg?v=1691333391',
                        comment: 'Navigatie besturing naast versnellingspook - bouwjaar voor 1 Feb 2017'
                    },
                    {
                        type: 'A6',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/a6_bouwjaar.jpg?v=1691337594',
                        comment: 'Bouwjaar voor 1 Jan 2016'
                    },
                    {
                        type: 'A7',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/a6_bouwjaar.jpg?v=1691337594',
                        comment: 'Bouwjaar voor 1 Jan 2016'
                    },
                    {
                        type: 'Q7',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/q7_bouwjaar.jpg?v=1691337886',
                        comment: 'Bouwjaar voor 1 Jan 2015'
                    },
                ],

            },
            {
                value: 'CD Changer',
                types: [
                    {
                        type: 'A4',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/cd_changer_2.jpg?v=1707068277',
                        comment: 'CD wisselaar in het midden console'
                    },
                    {
                        type: 'A5',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/cd_changer_2.jpg?v=1707068277',
                        comment: 'CD wisselaar in het midden console'
                    },
                    {
                        type: 'A6',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/cd_changer_2.jpg?v=1707068277',
                        comment: 'CD wisselaar systeem'
                    },
                    {
                        type: 'Q5',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/cd_changer_2.jpg?v=1707068277',
                        comment: 'CD wisselaar in het midden console'
                    },
                ],

            },
            {
                value: 'MIB',
                types: [
                    {
                        type: 'A3',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/a3_opklapscherm.jpg?v=1745441631',
                        comment: 'Uitklapscherm'
                    },
                    {
                        type: 'A4',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/a4_radio_3.jpg?v=1691333010',
                        comment: 'Vernieuwde navigatie besturing - bouwjaar na 1 Dec 2015'
                    },
                    {
                        type: 'A5',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/a4_radio_3.jpg?v=1691333010',
                        comment: 'Vernieuwde navigatie besturing - bouwjaar na 1 Juni 2015'
                    },
                    {
                        type: 'Q5',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/q5_radio_3.jpg?v=1691333403',
                        comment: 'Vernieuwde navigatie besturing - bouwjaar na 1 Feb 2017'
                    },
                    {
                        type: 'A6',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/a6_bouwjaar_na.jpg?v=1691337594',
                        comment: 'Bouwjaar na 1 Jan 2016'
                    },
                    {
                        type: 'A7',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/a6_bouwjaar_na.jpg?v=1691337594',
                        comment: 'Bouwjaar na 1 Jan 2016'
                    },
                    {
                        type: 'Q7',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/q7_bouwjaar_na.jpg?v=1691337886',
                        comment: 'Bouwjaar na 1 Jan 2015'
                    },
                    {
                        type: 'Q3',
                        img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/audi_q3_mib3.jpg?v=1738829460',
                        comment: 'Met Touchscherm'
                    }
                ],
            },
            {
                value: '3GMMI-systeem',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/Audi_q3_3gmmi.jpg?v=1738829459',
                comment: 'Uitklapbaar scherm'
            },
            {
                value: 'C6 3GMMI',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/Audi_q3_3gmmi.jpg?v=1738829459',
                comment: 'A6 C6 - 3GMMI systeem'
            },
            {
                value: 'RMC-systeem',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/rmc.jpg?v=1708345956',
            },
            {
              value: 'MIB3',
                img: 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/audi_q3_mib3.jpg?v=1738829460',
                comment: 'Met Touchscherm'
            }
        ]
    }
]

function infotainmentPicker(carSelectorWrapper, infotainmentSelectorWrapper) {
    if (!carSelectorWrapper || !infotainmentSelectorWrapper) return;
    const infotainmentSelectorButton = infotainmentSelectorWrapper.querySelector('button');
    const infotainmentSelectorMoreInfo = infotainmentSelectorWrapper.querySelector('.more_info_carplaybox_form');

    if (!infotainmentSelectorButton || !infotainmentSelectorMoreInfo) return;

    function runner() {
        const dropdownContent = infotainmentSelectorWrapper.querySelector('.t4s-dropdown__content');
        const dropdownCarContent = carSelectorWrapper.querySelector('.t4s-dropdown__content');
        if (!dropdownCarContent || !dropdownContent) return;

        const swatchItems = dropdownContent.querySelectorAll('.t4s-swatch__item:not(.is--soldout)');
        const selectedCar = dropdownCarContent.querySelector('.t4s-swatch__item.is--selected');
        if (!selectedCar || swatchItems.length === 0) return; // Als er geen niet-uitverkochte opties zijn, doe niets

        let infotainmentOptions = '';

        // Find the matching brand variation object
        const currentProductId = document.querySelector('.t4s-form__product').dataset.productid;

        const brandVariation = brandsVariations.find((variation) => variation.productid === currentProductId);

        swatchItems.forEach((item) => {
            const optionText = item.textContent.trim();
            const dataValue = item.getAttribute('data-value');
            const isSelected = item.classList.contains('is--selected');

            // Vind alle overeenkomende afbeeldings-URL's op basis van optionText
            const matchedImages = brandVariation.images.filter(image => {
                if (image.types && image.types.length && image.value === optionText) {
                    let state = false;
                    const innerSelectionCar = selectedCar.dataset.value;
                    if (innerSelectionCar && typeof innerSelectionCar === 'string') {
                        image.types.forEach(type => {
                            if (!state && innerSelectionCar.includes(type.type)) {
                                state = true;
                            }
                        });
                    }
                    return state;
                } else {
                    return image.value === optionText;
                }
            });

            // Verwerk elk overeenkomend afbeelding
            matchedImages.forEach(matchedImage => {
                let imgSrc = false;
                let order = 1;
                let comment = '';

                // Stel de afbeeldings-URL in
                if (matchedImage.types && matchedImage.types.length) {
                    const innerSelectionCar = selectedCar.dataset.value;
                    if (innerSelectionCar && typeof innerSelectionCar === 'string') {
                        matchedImage.types.forEach(type => {
                            if (innerSelectionCar.includes(type.type) && !imgSrc) {
                                imgSrc = type.img;
                                comment = type.comment ? type.comment : '';
                                order = type.order ? type.order : 1;
                            }
                        });
                    }
                } else if (matchedImage) {
                    comment = matchedImage.comment ? matchedImage.comment : '';
                    imgSrc = matchedImage.img;
                    order = matchedImage.order ? matchedImage.order : 1;
                } else {
                    imgSrc = '';
                }

                // Bouw de HTML string op
                infotainmentOptions += `
                <div class="custom-modal--infotainment--item${isSelected ? ' is--selected' : ''}" data-value="${dataValue}" style="order:${order ? order : 1};">
                    <img src="${imgSrc}">
                    <div class="label">
                      <span>${optionText}${comment ? ' - <small>' + comment + '</small>' : ''}</span>
                    </div>
                </div>
            `;
            });
        });

        var htmlInfotainmentPicker = `
      <div class="custom-modal--background"></div>
      <div class="custom-modal--wrapper">
          <div class="custom-modal--close"></div>
          <div class="custom-modal--inner">
              <h2>Welk infotainmentsysteem?</h2>
              <div class="custom-modal--content">
                <p>Welk type infotainmentsysteem heeft jouw auto? Kies 1 van de onderstaande opties. Hulp nodig of twijfels? Vraag de chat.</p>
              </div>
              <small class="custom-modal--description">${brandVariation.description}</small>
              <div class="custom-modal--infotainment">
                ${infotainmentOptions}
              </div>
          </div>
      </div>`;

        activatePopUp(htmlInfotainmentPicker);

        const infotainmentItems = document.querySelectorAll('.custom-modal--infotainment--item');
        infotainmentItems.forEach((infotainmentItem) => {
            infotainmentItem.addEventListener('click', () => {
                const dataValue = infotainmentItem.getAttribute('data-value');
                console.log('dataValue', dataValue);
                const matchingSwatchItem = dropdownContent.querySelector(`.t4s-swatch__item[data-value="${dataValue}"]`);
                console.log('matchingSwatchItem', matchingSwatchItem);
                if (matchingSwatchItem) {
                    matchingSwatchItem.dispatchEvent(new Event('click'));

                    swatchItems.forEach((item) => {
                        item.classList.remove('is--selected');
                    });

                    matchingSwatchItem.classList.add('is--selected');

                    const buttonSpan = infotainmentSelectorButton.querySelector('span');
                  
                    if (buttonSpan) {
                        buttonSpan.textContent = matchingSwatchItem.innerText;
                    }

                    // Get the text of the selected option from the dropdown [data-id="0"]
                    const modelOptionText = document.querySelector('.t4s-swatch__option[data-id="0"] .t4s-swatch__list button span').textContent.trim();

                    // Combine the model option with the infotainment option using a slash
                    const combinedOption = `${modelOptionText} / ${matchingSwatchItem.innerText}`;

                    // Find the corresponding option in the select and set it as the selected option
                    const productSelect = document.querySelector('.t4s-product__select');

                    if (productSelect) {
                        const matchedOption = [...productSelect.options].find((option) => option.textContent.trim() === combinedOption);

                        if (matchedOption) {
                            productSelect.value = matchedOption.value;
                            productSelect.dispatchEvent(new Event('change'));
                        }
                    }

                    const theCustomModal = document.querySelector('.custom-modal');
                    theCustomModal.remove();
                }
            });
        });
    }

    // Modal action
    infotainmentSelectorButton.addEventListener('click', () => {
        runner();
    });

    infotainmentSelectorMoreInfo.addEventListener('click', () => {
        runner();
    });
}

let intervalTime = 100;

const checkElements = () => {
    const carSelectorWrapper = document.querySelector('.t4s-selector-mode__dropdown [data-id="0"]');
    const infotainmentSelectorWrapper = document.querySelector('.t4s-selector-mode__dropdown [data-id="1"]');

    if (carSelectorWrapper && infotainmentSelectorWrapper) {
        infotainmentPicker(carSelectorWrapper, infotainmentSelectorWrapper)
        clearInterval(interval);
    } else {
        intervalTime *= 2;
        clearInterval(interval);
        interval = setInterval(checkElements, intervalTime);
    }
}

let interval = setInterval(checkElements, intervalTime);

function handleProductSelect() {
    const swatchOption = document.querySelector('.t4s-swatch__option[data-id="1"]');
    if (!swatchOption) return;

    const dropdownContent = swatchOption.querySelector('.t4s-dropdown__content');
    if (!dropdownContent) return;

    const swatchItems = dropdownContent.querySelectorAll('.t4s-swatch__item:not(.is--soldout)');

    if (swatchItems.length === 1) {
        swatchOption.classList.add('hidden');
    } else {
        swatchOption.classList.remove('hidden');
    }
}

const carplayboxForm = document.getElementById('carplayboxform');
const productSelect = document.querySelector('.t4s-product__select');

if (carplayboxForm && productSelect) {
    setTimeout(function () {
        handleProductSelect();
    }, 50);

    productSelect.addEventListener('change', handleProductSelect);
}


function checkSelectValue(selectElement) {
    const array = [
        '46721747681614',
        '46744525472078',
        '46744527962446',
        '46755747037518',
        '46744676860238',
        '44748999393571',
        '44748984418595',
        '44748999196963',
        '44748984451363',
        '44748984484131',
        '44748984516899',
        '44748984549667',
        '46931720175950',
        '46933198799182',
        '46933198930254',
        '46933202993486',
        '47064887558478',
        '47306281713998',
        '47336731967822',
        '47196100165966',
        '47196100198734',
        '47196100297038',
        '46710039937358',
        '46710048620878',
        '46710048719182',
        '46710040002894',
        '46710048817486',
        '46710048751950',
        '46710048784718',
        '46710040035662',
        '46710048915790',
        '46710040068430',
        '46710048981326',
        '46710049112398',
        '46710049145166',
        '46710049276238',
        '46710049636686',
        '46710049767758',
        '46710049702222',
        '49147179270478',
        '49147224981838',
        '49147225014606',
        '49147225047374',
        '49696602423630',
        '49696626737486',
        '49696630931790',
        '49696602620238',
        '49696616710478',
        '49696607764814'
    ];

    const selectedValue = selectElement.value;
    const getGpoContainer = document.querySelector('.gpo-container');

    if (array.includes(selectedValue)) {
        if (getGpoContainer) {
            const getMark = getGpoContainer.querySelector('mark');
            if (getMark) {
                getMark.remove();
            }
            ;

            const newMark = document.createElement("mark");
            newMark.dataset.state = 'warning'
            newMark.innerHTML = `
        <span><b>Advies:</b> Installatie door CarOptions</span><u><svg class="label-tooltip__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M12 24c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12zm1-6h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z"></path>
        </svg>Meer info</u>
        <span class="label-tooltip__content">De installatie van jouw geselecteerde CarPlayBox is door ons gekwalificeerd als geschikt voor gevorderden of een duidelijke handleiding ontbreekt. Ben jij klaar voor deze uitdaging? Als je twijfelt, adviseren we gebruik te maken van onze installatieservice. Voor meer informatie over de installatie, raadpleeg gerust de chat.</span>
      `;

            getGpoContainer.prepend(newMark);
        }
    } else {
        if (getGpoContainer) {
            const getMark = getGpoContainer.querySelector('mark');
            if (!getMark) return;
            getMark.remove();
        }
    }
}

let intervalTimeSelectValue = 100;
let attemptsSelectValue = 0;

const checkSelectValueIsSet = () => {
    const selector = document.querySelector(".t4s-form__product .t4s-product__select");

    if (selector) {
        selector.addEventListener('change', function () {
            checkSelectValue(selector);
        });
        checkSelectValue(selector);
        clearInterval(intervalSelectValue);
    } else {
        attemptsSelectValue++;
        if (attemptsSelectValue < 8) {
            intervalTimeSelectValue *= 2;
            clearInterval(intervalSelectValue);
            intervalSelectValue = setInterval(checkSelectValueIsSet, intervalTimeSelectValue);
        } else {
            clearInterval(intervalSelectValue);
        }
    }
}

let intervalSelectValue = setInterval(checkSelectValueIsSet, intervalTimeSelectValue);

const detectVideoImg = (theImg) => {
    theImg.style.pointerEvents = 'none';
    theImg.style.opacity = '0!important';
    theImg.style.visibility = 'hidden';

    const getParentImg = theImg.parentElement;

    if (!getParentImg) return;

    const findLazyLoad = getParentImg.querySelector('.lazyloadt4s-loader');

    if (findLazyLoad) {
        findLazyLoad.style.pointerEvents = 'none';
        findLazyLoad.style.opacity = '0 !important';
    }

    let iframeElement = document.createElement('iframe');
    iframeElement.classList.add('custom_video_445566')
    iframeElement.title = "CarPlayBox - CarOptions";
    iframeElement.src = "https://player.vimeo.com/video/1028225348";
    iframeElement.frameBorder = "0";
    iframeElement.allow = "autoplay; fullscreen; picture-in-picture";
    iframeElement.allowFullscreen = true;
    iframeElement.name = "fitvid0";

    let newImgElement = document.createElement('img');
    newImgElement.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0727/7477/9171/files/videoimgplaceholder445566_without.jpg?v=1691704272');
    let imgWrapperDiv = document.createElement('div');
    imgWrapperDiv.className = "video_img_placeholder_445566";
    imgWrapperDiv.appendChild(newImgElement);

    const initVideoPlayback = (iframeElement, imgWrapperDiv) => {
        imgWrapperDiv.remove();

        const theVideoFrame = document.querySelector('.custom_video_445566');

        if (theVideoFrame) {
            let theSrc = theVideoFrame.getAttribute('src');
            theSrc = theSrc + '?autoplay=1';

            theVideoFrame.setAttribute('src', theSrc);
        }
    };

    imgWrapperDiv.addEventListener('click', () => {
        initVideoPlayback(iframeElement, imgWrapperDiv);
    });

    getParentImg.insertBefore(imgWrapperDiv, getParentImg.firstChild);
    getParentImg.insertBefore(iframeElement, getParentImg.firstChild);
};

setInterval(() => {
    const theImg = document.querySelector('img[data-master*="videoimgplaceholder445566"]')
    const theWrapper = document.querySelector('.custom_video_445566');

    if (theImg && !theWrapper) {
        detectVideoImg(theImg);
    }
}, 1200);

let detectVideoImgInContentActive = {};

const videoConfigs = [
    {
        iframeSrc: "https://player.vimeo.com/video/1028225348",
        imgSelector: 'section[id*="e1f7e586e09e"] .t4s-img-child',
        uniqueClass: 'custom_video_445566_in_content',
    },
    {
        iframeSrc: "https://player.vimeo.com/video/1000987954",
        imgSelector: 'section[id*="CrM6WM"] .t4s-img-child',
        uniqueClass: 'custom_video_18130188337443_in_content'
    },
    {
        iframeSrc: "https://player.vimeo.com/video/1029152498",
        imgSelector: 'section[id*="c0dcc4e8"] .t4s-img-child',
        uniqueClass: 'custom_video_1029152498_in_content',
        productId: '8199566491939'
    },
    {
        iframeSrc: "https://player.vimeo.com/video/1032172601/",
        imgSelector: 'section[id*="e1f7e586e09d"] .t4s-img-child',
        uniqueClass: 'custom_video_1029152498_in_content',
        productId: '9858729378126'
    }
];

const detectVideoImgInContent = (config) => {
    const theImg = document.querySelector(config.imgSelector);
    if (!theImg) return;

    const findImg = theImg.querySelector('img');
    if (!findImg) return;

    let iframeElement = document.createElement('iframe');
    iframeElement.classList.add(config.uniqueClass);
    iframeElement.title = "CarPlayBox - CarOptions";
    iframeElement.src = config.iframeSrc;
    iframeElement.frameBorder = "0";
    iframeElement.allow = "autoplay; fullscreen; picture-in-picture";
    iframeElement.allowFullscreen = true;
    iframeElement.name = "fitvid0";

    const initVideoPlayback = () => {
        theImg.insertBefore(iframeElement, theImg.firstChild);

        const theImgDiv = theImg.querySelector('div');
        if (theImgDiv) theImgDiv.remove();

        const theVideoFrame = document.querySelector(`.${config.uniqueClass}`);
        if (theVideoFrame) {
            let theSrc = theVideoFrame.getAttribute('src') + '?autoplay=1';
            theVideoFrame.setAttribute('src', theSrc);

            theVideoFrame.addEventListener('load', () => {
                theVideoFrame.requestFullscreen().catch(err => {
                    console.log("Error attempting to enable full-screen mode: ", err.message);
                });
            });
        }
    };

    theImg.addEventListener('click', initVideoPlayback);
    detectVideoImgInContentActive[config.uniqueClass] = 1;
};

setInterval(() => {
    const pageProductId = document.querySelector('input[name="product-id"]')?.value;

    videoConfigs.forEach((config) => {
        // Als er een productId is in de configuratie, controleer of deze overeenkomt met pageProductId
        if (config.productId && config.productId !== pageProductId) return;

        const theImg = document.querySelector(config.imgSelector);
        const theWrapper = document.querySelector(`.${config.uniqueClass}`);

        if (theImg && !theWrapper && !detectVideoImgInContentActive[config.uniqueClass]) {
            detectVideoImgInContent(config);
        }
    });
}, 1200);



let intervalTimeAfterPay = 100;
let attemptsAfterPay = 0;

// Niet meer actief

const checkAfterPayIsSet = () => {
    var inputElement = document.querySelector('input[data-field-name="Achteraf betalen (5% aanbetaling)"]');

    if (inputElement) {

        inputElement.addEventListener('change', function () {
            setTimeout(() => {
                // Zoek het .t4s-product-price element
                var priceElement = document.querySelector('.t4s-product-price');

                // Zoek de <del> en <ins> elementen en bereken de nieuwe prijzen
                var delElement = priceElement.querySelector('del');
                var insElement = priceElement.querySelector('ins');

                var origDelPrice = parseFloat(delElement.textContent.replace('€', '').replace(',', '.'));
                var origInsPrice = parseFloat(insElement.textContent.replace('€', '').replace(',', '.'));

                var newDelPrice = origDelPrice * 0.05;
                var newInsPrice = origInsPrice * 0.05;

                if (this.checked) {
                    delElement.textContent = `€${newDelPrice.toFixed(2).replace('.', ',')}`;
                    insElement.textContent = `€${newInsPrice.toFixed(2).replace('.', ',')}`;

                    // Alleen een nieuw <small> element toevoegen als deze nog niet bestaat
                    if (!priceElement.querySelector('small')) {
                        var smallElement = document.createElement('small');
                        var smallText = `achteraf: €${(origInsPrice * 0.95).toFixed(2).replace('.', ',')}`;
                        smallElement.textContent = smallText;
                        priceElement.appendChild(smallElement);
                    }
                    // Voeg de class "afterTrue" toe aan priceElement
                    priceElement.classList.add('afterTrue');
                } else {
                    // Verwijder het <small> element als het bestaat
                    var existingSmall = priceElement.querySelector('small');
                    if (existingSmall) {
                        priceElement.removeChild(existingSmall);
                    }
                    // Verwijder de class "afterTrue" van priceElement
                    priceElement.classList.remove('afterTrue');
                }
            }, 900);
        });

        clearInterval(intervalAfterPay);
    } else {
        attemptsAfterPay++;
        if (attemptsAfterPay < 8) {
            intervalTimeAfterPay *= 2;
            clearInterval(intervalAfterPay);
            intervalAfterPay = setInterval(checkAfterPayIsSet, intervalTimeAfterPay);
        } else {
            clearInterval(intervalAfterPay);
        }
    }
}

let intervalAfterPay = setInterval(checkAfterPayIsSet, intervalTimeAfterPay);

if (1 + 1 === 3) {
    // Old code non Black Friday

    let intervalTimeAfterPay = 100;
    let attemptsAfterPay = 0;

    const updatePrice = () => {

        setTimeout(() => {

            // Zoek het .t4s-product-price element
            var priceElement = document.querySelector('.t4s-product-price');
            if (!priceElement) return;
            var delElement = priceElement.querySelector('del');
            var insElement = priceElement.querySelector('ins');

            if (!delElement) return;
            if (!insElement) return;

            var origDelPrice = parseFloat(delElement.textContent.replace('€', '').replace(',', '.'));
            var origInsPrice = parseFloat(insElement.textContent.replace('€', '').replace(',', '.'));

            var afterPayElement = document.querySelector('input[data-field-name="Achteraf betalen (5% aanbetaling)"]');
            var montageElement = document.querySelector('input[data-field-name="Montage en Installatie"]');

            if (!afterPayElement) return;
            if (!montageElement) return;

            var newDelPrice = origDelPrice;
            var newInsPrice = origInsPrice;

            // Controleer of de Montage en Installatie optie geselecteerd is
            if (montageElement.checked) {
                newDelPrice += 50; // Tel 50 euro op bij de originele prijs
            }

            // Controleer of de Achteraf betalen optie geselecteerd is
            if (afterPayElement.checked) {
                newDelPrice *= 0.05; // Vermenigvuldig de (mogelijk aangepaste) prijs met 5%
                newInsPrice *= 0.05;
            }

            // Update de prijzen
            delElement.textContent = `€${newDelPrice.toFixed(2).replace('.', ',')}`;
            insElement.textContent = `€${newInsPrice.toFixed(2).replace('.', ',')}`;

            // Update het <small> element
            var existingSmall = priceElement.querySelector('small');
            if (existingSmall) {
                priceElement.removeChild(existingSmall);
            }
            if (afterPayElement.checked) {
                var smallElement = document.createElement('small');
                var smallText = `achteraf: €${(origInsPrice * 0.95).toFixed(2).replace('.', ',')}`;
                smallElement.textContent = smallText;
                priceElement.appendChild(smallElement);
            }

            // Update de class "afterTrue"
            if (afterPayElement.checked) {
                priceElement.classList.add('afterTrue');
            } else {
                priceElement.classList.remove('afterTrue');
            }

        }, 750);
    };

    const checkOptionsAndSetListener = (inputElement, eventName) => {
        if (inputElement) {
            inputElement.addEventListener(eventName, updatePrice);
        }
    }

    const checkAfterPayIsSet = () => {
        var afterPayElement = document.querySelector('input[data-field-name="Achteraf betalen (5% aanbetaling)"]');
        var montageElement = document.querySelector('.gpo-select[data-field-name="Kies een installatie partner"]');

        checkOptionsAndSetListener(afterPayElement, 'change');
        checkOptionsAndSetListener(montageElement, 'change');

        if (afterPayElement && montageElement) {
            clearInterval(intervalAfterPay);
        } else {
            attemptsAfterPay++;
            if (attemptsAfterPay < 8) {
                intervalTimeAfterPay *= 2;
                clearInterval(intervalAfterPay);
                intervalAfterPay = setInterval(checkAfterPayIsSet, intervalTimeAfterPay);
            } else {
                clearInterval(intervalAfterPay);
            }
        }
    }

    let intervalAfterPay = setInterval(checkAfterPayIsSet, intervalTimeAfterPay);

}


$('.custom-foldout-productpage-wrapper').on('click', '.custom-foldout-productpage', function () {
    var $wrapper = $(this).closest('.t4s-tab-wrapper');

    // Controleer of de huidige tab al actief is
    if ($wrapper.hasClass('t4s-active')) {
        // Als het actief is, vouw het samen en verwijder de actieve klassen
        $wrapper.find('.t4s-tab-content').slideUp().removeClass('t4s-active');
        $wrapper.removeClass('t4s-active');
    } else {
        // Als het niet actief is, maak het actief en vouw het uit
        $wrapper.addClass('t4s-active');
        $wrapper.find('.t4s-tab-content').slideDown().addClass('t4s-active');
    }
});


let intervalCheckClickElement = 100;
let attemptsCheckClickElement = 0;

const checkElementAndSetClickListener = () => {
    const clickElement = document.querySelector('.product_smart_info .reputon-reviews-holder');
    const scrollTarget = document.querySelector('.reputon-reviews-holder.reputon-carousel');

    if (clickElement && scrollTarget) {
        clickElement.addEventListener('click', function () {
            scrollTarget.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
        clearInterval(intervalIdCheckClickElement);
    } else {
        attemptsCheckClickElement++;
        if (attemptsCheckClickElement < 10) {
            intervalCheckClickElement *= 2; // Verhoog de intervaltijd bij elke poging
            clearInterval(intervalIdCheckClickElement);
            intervalIdCheckClickElement = setInterval(checkElementAndSetClickListener, intervalCheckClickElement);
        } else {
            clearInterval(intervalIdCheckClickElement); // Stop de interval na meerdere pogingen
        }
    }
};

let intervalIdCheckClickElement = setInterval(checkElementAndSetClickListener, intervalCheckClickElement);


// ------------ Start Price Mutation code ------------

let intervalTimePriceMutation = 100;
let isPartnerLoggedIn = false; // Globale variabele om partnerstatus te detecteren

// Controleer op partner login status
function checkPartnerLoginStatus() {
    const stickyBar = document.querySelector('.sticky-bar');
    if (stickyBar && stickyBar.textContent.includes('U bent ingelogd als Partner')) {
        isPartnerLoggedIn = true;
    } else {
        isPartnerLoggedIn = false;
    }
}

const checkElementsPriceMutations = () => {
    const variantSelector = document.querySelector("select[name='id']");
    const productPriceElement = document.querySelector(".t4s-product-price");
    const gpoAppElement = document.querySelector(".gpo-app");

    if (variantSelector && productPriceElement && gpoAppElement) {
        checkPartnerLoginStatus();
        if (!isPartnerLoggedIn) {
           initializePriceUpdateFunctions(variantSelector, productPriceElement, gpoAppElement);
          clearInterval(intervalPriceMutation); 
        }
    } else {
        intervalTimePriceMutation *= 2;
        clearInterval(intervalPriceMutation);
        intervalPriceMutation = setInterval(checkElementsPriceMutations, intervalTimePriceMutation);
    }
};

let intervalPriceMutation = setInterval(checkElementsPriceMutations, intervalTimePriceMutation);

let originalDelPrice = null;
let originalInsPrice = null;
let originalSinglePrice = null;
let lastSelectedVariantId = null;

function formatPrice(price) {
    return price.replace(",00", ",-");
}

function calculateExtraPrice(gpoAppElement) {
    let extraPrice = 0;
    gpoAppElement.querySelectorAll('.gpo-element input[type="checkbox"]').forEach((checkbox) => {
        if (checkbox.checked && checkbox.hasAttribute('gpo-data-variant-id')) {
            const priceMatch = checkbox.closest('.gpo-element').className.match(/add-to-price--(\d+)/);
            if (priceMatch) {
                const price = parseFloat(priceMatch[1]);
                extraPrice += price;
            }
        }
    });
    gpoAppElement.querySelectorAll('.gpo-element select').forEach((select) => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption.hasAttribute('gpo-data-variant-id')) {
            const priceMatch = select.closest('.gpo-element').className.match(/add-to-price--(\d+)/);
            if (priceMatch) {
                const price = parseFloat(priceMatch[1]);
                extraPrice += price;
            }
        }
    });
    return extraPrice;
}

function resetOriginalPrices(productPriceElement, gpoAppElement) {
    setTimeout(function () {
        const delPriceElement = productPriceElement.querySelector('del');
        const insPriceElement = productPriceElement.querySelector('ins');
        const iTagExists = productPriceElement.querySelector('i') !== null;

        if (!iTagExists) {
            if (delPriceElement && insPriceElement) {
                originalDelPrice = parseFloat(delPriceElement.textContent.replace('€', '').replace(',', '.'));
                originalInsPrice = parseFloat(insPriceElement.textContent.replace('€', '').replace(',', '.'));
            } else {
                originalSinglePrice = parseFloat(productPriceElement.textContent.replace('€', '').replace(',', '.'));
            }

            updateProductPrice(productPriceElement, gpoAppElement);
        }
    }, 50);
}

function updateProductPrice(productPriceElement, gpoAppElement) {
    setTimeout(function () {
        const extraPrice = calculateExtraPrice(gpoAppElement);

        const delPriceElement = productPriceElement.querySelector('del');
        const insPriceElement = productPriceElement.querySelector('ins');

        if (delPriceElement && insPriceElement) {
            const newDelPrice = formatPrice((originalDelPrice + extraPrice).toFixed(2).replace('.', ','));
            const newInsPrice = formatPrice((originalInsPrice + extraPrice).toFixed(2).replace('.', ','));

            delPriceElement.innerHTML = `<i></i>€${newDelPrice}`;
            insPriceElement.innerHTML = `<i></i>€${newInsPrice}`;
        } else {
            const newPrice = formatPrice((originalSinglePrice + extraPrice).toFixed(2).replace('.', ','));
            productPriceElement.innerHTML = `<i></i>€${newPrice}`;
        }

        if (extraPrice === 0) {
            if (delPriceElement && insPriceElement) {
                delPriceElement.innerHTML = formatPrice(delPriceElement.textContent);
                insPriceElement.innerHTML = formatPrice(insPriceElement.textContent);
            } else {
                productPriceElement.innerHTML = formatPrice(productPriceElement.textContent);
            }
        }
    }, 50);
}

function initializePriceUpdateFunctions(variantSelector, productPriceElement, gpoAppElement) {
    lastSelectedVariantId = variantSelector.value;

    variantSelector.addEventListener("change", function () {
        const currentVariantId = variantSelector.value;

        if (currentVariantId !== lastSelectedVariantId) {
            lastSelectedVariantId = currentVariantId;
            resetOriginalPrices(productPriceElement, gpoAppElement);
        }
    });

    gpoAppElement.querySelectorAll('.gpo-element input[type="checkbox"]').forEach((checkbox) => {
        checkbox.addEventListener('change', function () {
            updateProductPrice(productPriceElement, gpoAppElement);
        });
    });

    gpoAppElement.querySelectorAll('.gpo-element select').forEach((select) => {
        select.addEventListener('change', function () {
            updateProductPrice(productPriceElement, gpoAppElement);
        });
    });

    resetOriginalPrices(productPriceElement, gpoAppElement);
    updateProductPrice(productPriceElement, gpoAppElement);
}

// ------------ End Price Mutation code ------------


// ------------ Start Volvo Touch Button Code ------------

let volvoTouchIntervalTime = 100;

const checkVolvoTouchElements = () => {
    const volvoTouchButton = document.querySelector('a[href="/touchscreen/toevoegen"]');
    const touchInput1 = document.querySelector('.tool_tip_camera_volvo input[type="checkbox"]');
    const touchInput2 = document.querySelector('.tool_tip_camera_volvo2 input[type="checkbox"]');
    const productPriceElement = document.querySelector(".t4s-product-price");
    const gpoAppElement = document.querySelector(".gpo-app");
    const scrollToButton = document.querySelector('.scroll_to_button_touch__button');
    
    if (volvoTouchButton && (touchInput1 || touchInput2) && productPriceElement && gpoAppElement) {
        initializeVolvoTouchButton(volvoTouchButton, touchInput1, touchInput2, productPriceElement, gpoAppElement);
        clearInterval(volvoTouchInterval);
    } else {
        volvoTouchIntervalTime *= 2;
        clearInterval(volvoTouchInterval);
        volvoTouchInterval = setInterval(checkVolvoTouchElements, volvoTouchIntervalTime);
    }
    
    if (scrollToButton) {
        scrollToButton.addEventListener('click', function () {
            scrollToElement('#shopify-section-template--18611221037347__c0dcc4e8-32f3-45fc-be2a-620fad89418c');
        });
    }
};

let volvoTouchInterval = setInterval(checkVolvoTouchElements, volvoTouchIntervalTime);

function initializeVolvoTouchButton(volvoTouchButton, touchInput1, touchInput2, productPriceElement, gpoAppElement) {
    volvoTouchButton.addEventListener('click', function (event) {
        event.preventDefault();

        let targetInput = null;

        if (touchInput1 && touchInput1.closest('[data-clo-display="hide"]')) {
            targetInput = touchInput1;
        } else if (touchInput2 && touchInput2.closest('[data-clo-display="hide"]')) {
            targetInput = touchInput2;
        }

        if (targetInput) {
            const testObject = document.querySelector('.gpo-element.gpo-form__group.tool_tip_camera_volvo.add-to-price--129');
            scrollToElement(testObject);

            setTimeout(function () {
                targetInput.checked = true;
                targetInput.dispatchEvent(new Event("change"));
                updateProductPrice(productPriceElement, gpoAppElement); // Re-run price mutation
            }, 800); // Wait 600ms after scroll to set the input
        }
    });
}

function scrollToElement(selector) {
    const targetElement = (typeof selector === 'string') ? document.querySelector(selector) : selector;
    
    if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        const elementCenter = rect.top + (rect.height / 2) + window.scrollY;
        const windowCenter = window.innerHeight / 2;
        const scrollToPosition = elementCenter - windowCenter;
        
        window.scrollTo({
            top: scrollToPosition,
            behavior: 'smooth'
        });
    }
}


// ------------ End Volvo Touch Button Code ------------


// ------------ Black Friday Sale ------------- //

let enableBlackFridaySlider = false; // Zet op true om de functionaliteit in te schakelen
let blackFridaySliderIntervalTime = 100;

const checkBlackFridaySliderElements = () => {
    if (!enableBlackFridaySlider) {
        console.log("Black Friday slider is uitgeschakeld.");
        clearInterval(blackFridaySliderInterval);
        return;
    }

    const mediaWrappers = document.querySelectorAll('[data-product-single-media-wrapper]');
    const productIdInput = document.querySelector('input[name="product-id"]');

    if (mediaWrappers.length > 0 && productIdInput) {
        initializeBlackFridaySliderFunctionality(mediaWrappers, productIdInput);
        clearInterval(blackFridaySliderInterval);
    } else {
        blackFridaySliderIntervalTime *= 2; // Verhoog intervaltijd exponentieel bij elke poging
        clearInterval(blackFridaySliderInterval);
        blackFridaySliderInterval = setInterval(checkBlackFridaySliderElements, blackFridaySliderIntervalTime);
    }
};

let blackFridaySliderInterval = setInterval(checkBlackFridaySliderElements, blackFridaySliderIntervalTime);

function initializeBlackFridaySliderFunctionality(mediaWrappers, productIdInput) {
    const productDiscounts = [
        { id: '9858729378126', discount: 30 }
    ];

    function getBlackFridayDiscount(productId) {
        const product = productDiscounts.find(item => item.id === productId);
        return product ? product.discount : 100; // Als geen specifieke korting, standaard €100
    }

    const currentProductId = productIdInput.value;
    const discount = getBlackFridayDiscount(currentProductId);

    mediaWrappers.forEach((wrapper, index) => {
        if (index < 2) {
            const saleDiv = document.createElement('div');
            saleDiv.className = 'sale--black-friday';
            saleDiv.innerHTML = `
                <strong>KERST SALE!</strong>
                <small>Nu €${discount},- Korting!</small>
            `;
            wrapper.appendChild(saleDiv);
        }
    });

    console.log(`Div toegevoegd met korting van €${discount},- aan de eerste twee slides.`);
}

// ------------ END Black Friday Sale ------------- //

if (1 === 2) {

    const startDiv = document.querySelector('.t4s-announcement-bar');

    function createParticle(x, y, angle, distance) {
        const particle = document.createElement('div');
        particle.classList.add('particle');
        startDiv.appendChild(particle);

        const velocityX = Math.cos(angle) * distance;
        const velocityY = Math.sin(angle) * distance;

        particle.style.left = `${x}px`;
        particle.style.top = `${y}px`;

        particle.animate([
            {transform: 'translate(0, 0)', opacity: 1},
            {transform: `translate(${velocityX}px, ${velocityY}px)`, opacity: 0}
        ], {
            duration: 800 + Math.random() * 200,
            easing: 'ease-out'
        }).onfinish = () => {
            particle.remove();
        };
    }

    function explode() {
        const x = Math.random() * startDiv.offsetWidth;
        const y = Math.random() * startDiv.offsetHeight;
        const numberOfParticles = 50;
        const angleIncrement = (Math.PI * 2) / numberOfParticles;

        for (let i = 0; i < numberOfParticles; i++) {
            const angle = i * angleIncrement;
            const distance = 40 + Math.random() * 20;
            createParticle(x, y, angle, distance);
        }
    }

    function triggerExplosion() {
        const randomDelay = Math.random() * 1500; // Verlaagde maximale vertraging tot 2000 ms

        setTimeout(() => {
            explode(); // Start één explosie
            triggerExplosion(); // Plan de volgende explosie
        }, randomDelay);
    }

    triggerExplosion(); // Start de eerste explosie


    const nightSky = document.querySelector('.t4s-announcement-bar');
    const numberOfStars = 100; // Aantal sterren

    for (let i = 0; i < numberOfStars; i++) {
        const star = document.createElement('div');
        star.classList.add('star');
        star.style.left = Math.random() * 100 + '%';
        star.style.top = Math.random() * 100 + '%';

        // Willekeurige animatieduur en vertraging voor meer realisme
        star.style.animationDuration = Math.random() * 3 + 1 + 's';
        star.style.animationDelay = Math.random() * 2 + 's';

        nightSky.appendChild(star);
    }
}
